import { Component, Input } from '@angular/core'
import { FormControl } from '@angular/forms'
import { UFDomainModel, UFDomainModelList } from '@shared/models/backend'
import {
  createDefaultSelectFieldProvider,
  SelectFieldProvider,
} from 'src/app/widgets/select-field/select-field-provider'

export interface UFModelRegiao extends UFDomainModel {
  siglaRegiao: string
}

@Component({
  selector: 'app-uf',
  templateUrl: './uf.component.html',
})
export class UfComponent {
  ufProvider: SelectFieldProvider<UFModelRegiao> = createDefaultSelectFieldProvider<UFModelRegiao>(UFDomainModelList)
  @Input() ufForm: FormControl
  // Indica em qual form o componente está inserido
  @Input()
  idForm: string
}
